import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NavigationService } from '../../../../services/navigation.service';
import { HtmlDescriptionFieldComponent } from '../../../fields/standard/html-description-field/html-description-field.component';
import { NameFieldComponent } from '../../../fields/standard/name-field/name-field.component';
import { TextFieldComponent } from '../../../fields/standard/text-field/text-field.component';
import { Lesson, LessonText, TextUtils, _ } from '@mira-avant/mtlibs';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { FormTitleComponent } from '../../../ui/forms/form-title/form-title.component';
import { PreviousImageSelectorComponent } from '../../../ui/admin/previous-image-selector/previous-image-selector.component';

@Component({
	selector: 'app-lesson-form',
	standalone: true,
	imports: [
		AppModule,
		ZorroModule,
		ThirdPartyModule,
		AngularModule,
		NameFieldComponent,
		HtmlDescriptionFieldComponent,
		TextFieldComponent,
		FormTitleComponent,
		PreviousImageSelectorComponent,
	],
	templateUrl: './lesson-form.component.html',
	styleUrl: './lesson-form.component.scss',
})
export class LessonFormComponent implements OnInit {
	@Input('lesson') public lesson: Lesson | undefined;
	@Input('editLanguage') public editLanguage: string | undefined;
	@Output('onSubmit') public onSubmitEmitter: EventEmitter<any> = new EventEmitter<any>();

	public showPreviousImageSelector: boolean = false;

	public form: FormGroup = this.fb.group({
		name: ['', NameFieldComponent.validators],
		descriptionHtml: ['', TextFieldComponent.validators],
		descriptionShort: ['', HtmlDescriptionFieldComponent.validators],
		imageUri: ['', TextFieldComponent.validators],
		//dataJson: ['', []],
	});

	constructor(
		private fb: FormBuilder,
		public nav: NavigationService
	) {}

	public onSubmit() {
		const value = this.form.getRawValue();

		this.onSubmitEmitter.emit({
			...value,
			descriptionShort: TextUtils.toOptionalText(value.descriptionShort),
			descriptionHtml: TextUtils.toOptionalText(value.descriptionHtml),
		});
	}

	public clear(): void {
		this.form.reset();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (_.get(changes, 'editLanguage', undefined) || _.get(changes, 'lesson', undefined)) {
			if (changes['lesson']) {
				const newLesson: Lesson | undefined = _.get(changes, 'lesson.currentValue', undefined) as
					| Lesson
					| undefined;

				this.lesson = newLesson;
			}

			const newLessonText: LessonText | undefined = this.lesson
				? this.lesson.lesson_text.find((text: LessonText) => text.default_lang_id === this.editLanguage)
				: undefined;

			this.form.patchValue({
				name: newLessonText?.name || '',
				descriptionHtml: newLessonText?.description_html ?? null,
				descriptionShort: newLessonText?.description_short ?? null,
				imageUri: newLessonText?.image_uri || '',
				//dataJson: this.lesson?.data_json ? JSON.stringify(this.lesson?.data_json) : '',
			});
		}
	}

	public selectImageUri(imageUri: string): void {
		this.form.patchValue({ imageUri });
		this.showPreviousImageSelector = false;
	}

	ngOnInit() {}
}
